import React, { useEffect, useState } from "react";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import DatePicker from "react-datepicker";

import CircularProgress from "@mui/material/CircularProgress";

import "react-datepicker/dist/react-datepicker.css";

import Popup from "../Popup";

import {
  getActiveKycServices,
  requestAadhaarOtp,
  verifyAadhaarOtp,
  verifyDrivingLicence,
  verifyPan,
} from "../../javaAxiosConfig";

import lightArrowRight from "../../images/arrow-leftBack.svg";
import accountsettingDesign from "../../images/accountsettingDesign.png";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

import aadhaarCardPlaceholder from "../../images/aadhaar-cardPlaceholder.png";
import panCardPlaceholder from "../../images/pan-cardPlaceholder.png";

import drivingLCardPlaceholder from "../../images/drivingL-cardPlaceholder.png";
import { justifyContent } from "@mui/system";

export const KYCVerification = () => {
  const navigate = useNavigate();

  const [services, setServices] = useState([]);
  const [selectedService, setSelectedService] = useState(null);

  const [aadhaarNumber, setAadhaarNumber] = useState("");
  const [aadhaarError, setAadhaarError] = useState("");

  const [orderId, setOrderId] = useState(null);

  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");

  const OTP_DURATION = 120; // 2 minutes
  const [resendTimer, setResendTimer] = useState(OTP_DURATION);

  const [canResend, setCanResend] = useState(false);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const [panNumber, setPanNumber] = useState("");

  const [dlNumber, setDlNumber] = useState("");

  const [dlDob, setDlDob] = useState(null); // DateValue | null
  const [dlDobError, setDlDobError] = useState("");

  const [aadhaarStep, setAadhaarStep] = useState("FORM");
  // FORM | OTP

  const [isRequestingOtp, setIsRequestingOtp] = useState(false);

  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);

  const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);

  const [shouldRedirect, setShouldRedirect] = useState(false);

  const [isConfirmed, setIsConfirmed] = useState(false);

  const [popup, setPopup] = useState({
    open: false,
    type: "success",
    title: "",
    message: "",
  });

  useEffect(() => {
    fetchServices();
  }, []);

  const normalizeService = (serviceName) => {
    if (serviceName.includes("Aadhaar")) return "AADHAAR";
    if (serviceName.includes("PAN")) return "PAN";
    if (serviceName.includes("Driving")) return "DL";
    return null;
  };

  const ConfirmationCheckbox = ({ isConfirmed, setIsConfirmed }) => (
    <div style={checkboxRowStyle}>
      <input
        type="checkbox"
        checked={isConfirmed}
        onChange={(e) => setIsConfirmed(e.target.checked)}
        style={{ width: 18, height: 18 }}
      />
      <span style={{ fontSize: 14, color: "#555" }}>
        I confirm that the provided details are true, accurate, and complete.
      </span>
    </div>
  );

  const fetchServices = async () => {
    try {
      const res = await getActiveKycServices();

      const list = res.data
        .filter((item) => item.isActive === 1)
        .map((item) => ({
          label: item.serviceName,
          value: item.serviceName.includes("Aadhaar")
            ? "AADHAAR"
            : item.serviceName.includes("PAN")
              ? "PAN"
              : "DL",
        }));

      setServices(list);
      //   setSelectedService(list[0]); // auto select first
      setSelectedService(null);
    } catch (err) {
      toast.error("Failed to load KYC services");
    }
  };

  const formatTimer = (seconds) => {
    const m = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

  const formatDobForApi = (dob) => {
    if (!dob) return null;
    const d = dob.getDate().toString().padStart(2, "0");
    const m = (dob.getMonth() + 1).toString().padStart(2, "0");
    const y = dob.getFullYear();
    return `${d}-${m}-${y}`;
  };

  // const getMaxDobDate = () => {
  //   const today = new Date();
  //   today.setFullYear(today.getFullYear() - 18);
  //   return today;
  // };

  const isAdult = (dob) => {
    const today = new Date();
    const adultDate = new Date(
      today.getFullYear() - 18,
      today.getMonth(),
      today.getDate(),
    );
    return dob <= adultDate;
  };

  const handleVerifyDl = async () => {
    if (!dlNumber || dlNumber.length < 10) {
      setDlError("Enter valid Driving Licence number");
      return;
    }

    if (!dlDob) {
      setDlDobError("Please select Date of Birth");
      return;
    }
    if (!isAdult(dlDob)) {
      setDlDobError("You must be at least 18 years old");
      return;
    }

    try {
      console.log("DL VERIFY TOKEN FROM UI 👉", localStorage.getItem("token"));

      const payload = {
        driving_licence_number: dlNumber,
        date_of_birth: formatDobForApi(dlDob),
      };

      const res = await verifyDrivingLicence(payload);

      const { status, message } = res?.data || {};

      const normalizedStatus = status?.toString().toLowerCase();
      console.log("DL API STATUS =", normalizedStatus);

      const popupMessage =
        message ||
        (status === "manual_review"
          ? "Your driving licence verification is under manual review."
          : status === "approved"
            ? "Your driving licence has been verified successfully."
            : "Driving licence verification submitted.");

      const popupTitle =
        status === "manual_review"
          ? "Verification In Progress"
          : status === "approved"
            ? "Verification Successful"
            : "Verification Update";

      setPopup({
        open: true,
        type: "success",
        title: popupTitle,
        message: popupMessage,
      });

      if (
        normalizedStatus === "approved" ||
        normalizedStatus === "success" ||
        normalizedStatus === "manual_review"
      ) {
        setShouldRedirect(true);
      }
    } catch (err) {
      setPopup({
        open: true,
        type: "error",
        title: "Verification Failed",
        message:
          err?.response?.data?.message ||
          "Driving licence verification failed.",
      });
    }
  };

  const handleVerifyPan = async () => {
    if (!PAN_REGEX.test(panNumber)) {
      setPanError("Enter valid PAN (ABCDE1234F)");
      return;
    }

    try {
      const res = await verifyPan({ pan_number: panNumber });

      const { status, message } = res?.data || {};
      const normalizedStatus = status?.toString().toLowerCase();
      console.log("PAN API STATUS =", normalizedStatus);

      const popupTitle =
        status === "manual_review"
          ? "Verification In Progress"
          : status === "approved"
            ? "Verification Successful"
            : "Verification Update";

      setPopup({
        open: true,
        type: "success",
        title: popupTitle,
        message: message || "PAN verification submitted successfully.",
      });

      if (
        normalizedStatus === "approved" ||
        normalizedStatus === "success" ||
        normalizedStatus === "manual_review"
      ) {
        setShouldRedirect(true);
      }
    } catch (err) {
      setPopup({
        open: true,
        type: "error",
        title: "Verification Failed",
        message: err?.response?.data?.message || "PAN verification failed.",
      });
    }
  };

  const handleAadhaarChange = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // only numbers

    if (value.length <= 12) {
      setAadhaarNumber(value);
    }
  };

  const PAN_REGEX = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

  const [panError, setPanError] = useState("");

  const handlePanChange = (e) => {
    const value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
    if (value.length <= 10) {
      setPanNumber(value);
      setPanError(
        value.length === 10 && !PAN_REGEX.test(value)
          ? "Enter valid PAN (ABCDE1234F)"
          : "",
      );
    }
  };

  const [dlError, setDlError] = useState("");

  const handleDlChange = (e) => {
    const value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
    setDlNumber(value);

    setDlError(
      value.length > 0 && value.length < 10
        ? "Enter valid Driving Licence number"
        : "",
    );
  };

  const handleRequestOtp = async () => {
    if (!/^\d{12}$/.test(aadhaarNumber)) {
      setAadhaarError("Enter valid 12-digit Aadhaar number");
      return;
    }

    setIsRequestingOtp(true); // ✅ START LOADER

    try {
      const res = await requestAadhaarOtp({ aadhaar_number: aadhaarNumber });

      setOrderId(res.data.task_id);
      setAadhaarStep("OTP");
      startTimer();

      setIsOtpModalOpen(true);

      setPopup({
        open: true,
        type: "success",
        title: "OTP Sent",
        message: res.data.message || "OTP sent successfully",
      });
    } catch (err) {
      setPopup({
        open: true,
        type: "error",
        title: "Error",
        message: err?.response?.data?.message || "Failed to send OTP",
      });
    } finally {
      setIsRequestingOtp(false); // ✅ STOP LOADER (SUCCESS / ERROR)
    }
  };

  const timerRef = React.useRef(null);

  const startTimer = () => {
    setCanResend(false);
    setResendTimer(OTP_DURATION);

    if (timerRef.current) clearInterval(timerRef.current);

    timerRef.current = setInterval(() => {
      setResendTimer((t) => {
        if (t <= 1) {
          clearInterval(timerRef.current);
          timerRef.current = null;
          setCanResend(true);
          return 0;
        }
        return t - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);

  const handleVerifyOtp = async () => {
    if (!/^\d{6}$/.test(otp)) {
      setOtpError("Enter valid 6-digit OTP");
      return;
    }

    setIsVerifyingOtp(true); // ✅ START LOADER

    try {
      const res = await verifyAadhaarOtp({ otp, taskId: orderId });

      const { status, message, approval_type } = res?.data || {};

      const normalizedStatus = status?.toString().toLowerCase();
      const normalizedApprovalType = approval_type?.toString().toLowerCase();

      console.log("AADHAAR API STATUS =", normalizedStatus);
      console.log("AADHAAR APPROVAL TYPE =", normalizedApprovalType);

      let popupTitle = "Verification Update";
      let popupMessage = message || "Aadhaar verification submitted.";

      if (
        normalizedStatus === "pending" &&
        normalizedApprovalType === "manual"
      ) {
        popupTitle = "Verification In Progress";
      }

      if (normalizedStatus === "approved" || normalizedStatus === "success") {
        popupTitle = "Verification Successful";
      }

      setPopup({
        open: true,
        type: "success",
        title: popupTitle,
        message: popupMessage,
      });

      //    if (normalizedStatus === "approved" || normalizedStatus === "success") {
      //   setShouldRedirect(true);
      // }

      if (
        normalizedStatus === "approved" ||
        normalizedStatus === "success" ||
        normalizedStatus === "manual_review"

          (normalizedStatus === "pending" &&
    normalizedApprovalType === "manual")
)
       {
        setShouldRedirect(true);
      }

      setIsOtpModalOpen(false);
    } catch (err) {
      setPopup({
        open: true,
        type: "error",
        title: "Verification Failed",
        message:
          err?.response?.data?.message ||
          "OTP verification failed. Please try again.",
      });
    } finally {
      setIsVerifyingOtp(false); // ✅ STOP LOADER
    }
  };

  const handleOtpChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 6);
    setOtp(value);
    if (otpError) setOtpError("");
  };

  useEffect(() => {
    if (isOtpModalOpen) {
      setTimeout(() => {
        document.getElementById("otp-hidden-input")?.focus();
      }, 100);
    }
  }, [isOtpModalOpen]);

  return (
    <div className="col-lg-9 col-12">
      <div style={{ padding: 24 }}>
        {/* HEADER OUTSIDE CARD */}
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <img
            src={lightArrowRight}
            alt="Back"
            style={{ cursor: "pointer", width: 22 }}
            onClick={() => navigate(-1)}
          />
          <span style={{ fontWeight: 600, color: "#FF7A00", fontSize: 18 }}>
            KYC Verification
          </span>
        </div>

        {/* CARD */}
        <div style={cardStyle}>
          <div style={titleStyle}>
            {selectedService
              ? selectedService.label.replace("Verification", "Card Details")
              : "Select Your ID"}
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img
              src={accountsettingDesign}
              alt="divider"
              style={{
                display: "block",
                margin: "20px auto 40px",
                width: "32%",
              }}
            />
          </div>

          <div
            style={{
              position: "relative",
              marginBottom: "32px",
            }}
          >
            <div
              onClick={() => setIsDropdownOpen((prev) => !prev)}
              style={{
                height: "55px",
                borderRadius: "9px",
                border: "1px solid rgba(79,79,79,0.12)",
                display: "flex",
                alignItems: "center",
                padding: "0 20px",
                justifyContent: "space-between",
                cursor: "pointer",
                background: "#fff",
              }}
            >
              <span>
                {selectedService ? selectedService.label : "Select Your ID"}
              </span>
              {isDropdownOpen ? <FaChevronUp /> : <FaChevronDown />}
            </div>

            {isDropdownOpen && (
              <div
                style={{
                  position: "absolute",
                  top: "60px",
                  width: "100%",
                  background: "#fff",
                  border: "1px solid rgba(79,79,79,0.12)",
                  borderRadius: "9px",
                  zIndex: 10,
                }}
              >
                {services.map((item) => (
                  <div
                    key={item.value}
                    onClick={() => {
                      setSelectedService(item);
                      setIsDropdownOpen(false);

                      // 🔄 Reset shared states
                      setIsConfirmed(false);
                      setAadhaarStep("FORM");
                      setOtp("");
                      setOtpError("");
                      setOrderId(null);

                      // 🔄 Reset Aadhaar
                      setAadhaarNumber("");
                      setAadhaarError("");

                      // 🔄 Reset PAN
                      setPanNumber("");
                      setPanError("");

                      // 🔄 Reset DL
                      setDlNumber("");
                      setDlError("");
                      setDlNumber("");

                      setDlDob("");
                      setDlDobError("");
                    }}
                    style={{
                      padding: "14px 20px",
                      cursor: "pointer",
                    }}
                  >
                    {item.label}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Aadhaar Input */}
          {selectedService?.value === "AADHAAR" && (
            <>
              <div style={fieldRowStyle}>
                <label style={fieldLabelStyle}>Aadhaar Number</label>

                <div style={inputWithIconWrapper}>
                  <input
                    style={{
                      ...inputWithIconStyle,
                      backgroundColor:
                        aadhaarStep === "OTP" ? "#f5f5f5" : "#fff",
                      cursor: aadhaarStep === "OTP" ? "not-allowed" : "text",
                    }}
                    placeholder="xxxx xxxx xxxx"
                    value={aadhaarNumber}
                    onChange={handleAadhaarChange}
                    disabled={aadhaarStep === "OTP"}
                  />

                  <img
                    src={aadhaarCardPlaceholder}
                    alt="aadhaar"
                    style={inputIconStyle}
                  />
                </div>
              </div>

              {aadhaarError && (
                <div style={{ color: "red" }}>{aadhaarError}</div>
              )}

              <ConfirmationCheckbox
                isConfirmed={isConfirmed}
                setIsConfirmed={setIsConfirmed}
              />

              <button
                style={{
                  ...verifyBtnStyle,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                  opacity:
                    aadhaarStep === "FORM"
                      ? isConfirmed &&
                        aadhaarNumber.length === 12 &&
                        !isRequestingOtp
                        ? 1
                        : 0.5
                      : 1,
                  cursor:
                    aadhaarStep === "FORM"
                      ? isConfirmed &&
                        aadhaarNumber.length === 12 &&
                        !isRequestingOtp
                        ? "pointer"
                        : "not-allowed"
                      : "pointer",
                }}
                disabled={
                  (aadhaarStep === "FORM" &&
                    (!isConfirmed ||
                      aadhaarNumber.length !== 12 ||
                      isRequestingOtp)) ||
                  (aadhaarStep === "OTP" &&
                    (otp.length !== 6 || isVerifyingOtp))
                }
                onClick={aadhaarStep === "FORM" ? handleRequestOtp : undefined}
              >
                {/* 🔥 LOADER */}
                {aadhaarStep === "FORM" && isRequestingOtp && (
                  <CircularProgress
                    size={18}
                    thickness={5}
                    sx={{ color: "#fff" }}
                  />
                )}

                {aadhaarStep === "OTP" && isVerifyingOtp && (
                  <CircularProgress
                    size={18}
                    thickness={5}
                    sx={{ color: "#fff" }}
                  />
                )}

                {/* 🔥 BUTTON TEXT */}
                <span>
                  {aadhaarStep === "FORM"
                    ? isRequestingOtp
                      ? "Requesting OTP"
                      : "Request OTP"
                    : isVerifyingOtp
                      ? "Verifying OTP"
                      : "Verify"}
                </span>
              </button>
            </>
          )}

          {selectedService?.value === "PAN" && (
            <>
              <div style={fieldRowStyle}>
                <label style={fieldLabelStyle}>PAN Number</label>

                <div style={inputWithIconWrapper}>
                  <input
                    style={inputWithIconStyle}
                    placeholder="ABCDE1234F"
                    value={panNumber}
                    onChange={handlePanChange}
                  />
                  <img
                    src={panCardPlaceholder}
                    alt="pan"
                    style={inputIconStyle}
                  />
                </div>
              </div>

              {/* 🔴 PAN ERROR MESSAGE — ADD THIS */}
              {panError && (
                <div style={{ color: "red", fontSize: 13, marginTop: "-16px" }}>
                  {panError}
                </div>
              )}

              {/* ✅ CONFIRMATION CHECKBOX */}
              <ConfirmationCheckbox
                isConfirmed={isConfirmed}
                setIsConfirmed={setIsConfirmed}
              />

              {/* ✅ VERIFY BUTTON */}
              <VerifyButton
                disabled={!isConfirmed || panNumber.length !== 10 || !!panError}
                onClick={handleVerifyPan}
              />
            </>
          )}

          {selectedService?.value === "DL" && (
            <>
              {/* DOB */}
              {/* DOB */}
              {/* DOB Picker */}
              <div
                style={{
                  ...fieldRowStyle,
                  gap: "97px",
                }}
              >
                <label style={fieldLabelStyle}>Date of Birth</label>

                <div
                  style={{
                    width: "90%",
                    position: "relative",
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                >
                  <DatePicker
                    selected={dlDob}
                    onChange={(date) => {
                      setDlDob(date);
                      setDlDobError("");
                    }}
                    //   maxDate={isAdult()}
                    maxDate={(() => {
                      const d = new Date();
                      d.setFullYear(d.getFullYear() - 18);
                      return d;
                    })()}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="DD-MM-YYYY"
                    onKeyDown={(e) => e.preventDefault()} // ✅ disable typing
                    showPopperArrow={false}
                    calendarClassName="kyc-calendar"
                    className="kyc-datepicker"
                    renderCustomHeader={({
                      date,
                      decreaseMonth,
                      increaseMonth,
                      changeYear,
                      changeMonth,
                    }) => (
                      <div className="kyc-calendar-header">
                        <button onClick={decreaseMonth}>‹</button>

                        <select
                          value={date.getMonth()}
                          onChange={(e) => changeMonth(Number(e.target.value))}
                        >
                          {Array.from({ length: 12 }).map((_, i) => (
                            <option key={i} value={i}>
                              {new Date(0, i).toLocaleString("default", {
                                month: "long",
                              })}
                            </option>
                          ))}
                        </select>

                        <select
                          value={date.getFullYear()}
                          onChange={(e) => changeYear(Number(e.target.value))}
                        >
                          {Array.from({ length: 80 }).map((_, i) => {
                            const year = new Date().getFullYear() - 18 - i;
                            return (
                              <option key={year} value={year}>
                                {year}
                              </option>
                            );
                          })}
                        </select>

                        <button onClick={increaseMonth}>›</button>
                      </div>
                    )}
                  />

                  {/* Custom calendar icon */}
                </div>
              </div>

              {dlDobError && (
                <div style={{ color: "red", fontSize: 13, marginTop: "-16px" }}>
                  {dlDobError}
                </div>
              )}

              {/* DL NUMBER */}
              <div style={fieldRowStyle}>
                <label style={fieldLabelStyle}>Driving Licence Number</label>

                <div style={inputWithIconWrapper}>
                  <input
                    style={inputWithIconStyle}
                    placeholder="DLXXXXXXXXXX"
                    value={dlNumber}
                    onChange={handleDlChange}
                  />
                  <img
                    src={drivingLCardPlaceholder}
                    alt="dl"
                    style={inputIconStyle}
                  />
                </div>
              </div>

              {dlError && (
                <div style={{ color: "red", fontSize: 13, marginTop: "-16px" }}>
                  {dlError}
                </div>
              )}

              <ConfirmationCheckbox
                isConfirmed={isConfirmed}
                setIsConfirmed={setIsConfirmed}
              />

              <VerifyButton
                disabled={
                  !isConfirmed ||
                  dlNumber.length < 10 ||
                  !dlDob ||
                  !!dlError ||
                  !!dlDobError
                }
                onClick={handleVerifyDl}
              />
            </>
          )}
        </div>
      </div>

      {isOtpModalOpen && (
        <div style={otpModalOverlay}>
          <div style={otpModalCard}>
            {/* <h3 style={{ marginBottom: 16 }}>Enter OTP</h3> */}

            {/* MODAL HEADER */}
            <div
              style={{
                textAlign: "center",
                marginBottom: 20,
              }}
            >
              <h5 style={{ margin: 0, fontWeight: 600 }}>Verify Aadhaar</h5>

              <p
                style={{
                  fontSize: 13,
                  color: "#777",
                  marginTop: 6,
                  lineHeight: 1.4,
                }}
              >
                Enter the 6-digit OTP sent to your Aadhaar-linked mobile number
              </p>
            </div>

            {/* OTP BOXES */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: 20,
                marginBottom: 10,
              }}
              onClick={() =>
                document.getElementById("otp-hidden-input").focus()
              }
            >
              {Array.from({ length: 6 }).map((_, i) => {
                const isActive = i === otp.length && otp.length < 6;
                const hasValue = !!otp[i];

                return (
                  <div
                    key={i}
                    style={{
                      width: "48px",
                      height: "54px",
                      borderRadius: "10px",
                      border: isActive
                        ? "2px solid #FF7A00"
                        : hasValue
                          ? "1.5px solid #FFB37A"
                          : "1.5px solid #ddd",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "20px",
                      fontWeight: 600,
                      background: "#fff",
                      transition: "all 0.2s",
                    }}
                  >
                    {hasValue ? (
                      otp[i]
                    ) : isActive ? (
                      <span style={otpCaretStyle} />
                    ) : (
                      ""
                    )}
                  </div>
                );
              })}
            </div>

            {/* HIDDEN REAL INPUT */}
            <input
              id="otp-hidden-input"
              type="tel"
              autoFocus
              value={otp}
              onChange={handleOtpChange}
              maxLength={6}
              style={{
                position: "absolute",
                opacity: 0,
                pointerEvents: "none",
              }}
            />

            {otpError && (
              <div style={{ color: "red", marginTop: 8 }}>{otpError}</div>
            )}

            <button
              style={{
                ...verifyBtnStyle,
                width: "100%",
                marginTop: 20,
                display: "flex",
                justifyContent: "center",
                gap: 10,
              }}
              disabled={otp.length !== 6 || isVerifyingOtp}
              onClick={handleVerifyOtp}
            >
              {isVerifyingOtp && (
                <CircularProgress size={18} sx={{ color: "#fff" }} />
              )}
              {isVerifyingOtp ? "Verifying OTP" : "Verify OTP"}
            </button>

            <div
              style={{
                marginTop: 14,
                fontSize: 13,
                color: canResend ? "#FF6A00" : "#ccc",
                cursor: canResend ? "pointer" : "not-allowed",
                textAlign: "center",
              }}
              onClick={canResend ? handleRequestOtp : undefined}
            >
              Resend OTP {canResend ? "" : `(${formatTimer(resendTimer)})`}
            </div>

            <div
              style={{
                marginTop: 14,
                textAlign: "center",
                fontSize: 13,
                color: "#777",
                cursor: "pointer",
              }}
              onClick={() => {
                setIsOtpModalOpen(false);
                setAadhaarStep("FORM");
                setOtp("");
                setOtpError("");
              }}
            >
              Change Aadhaar Number
            </div>
          </div>
        </div>
      )}

      <Popup
        open={popup.open}
        type={popup.type}
        title={popup.title}
        message={popup.message}
        // onClose={() => setPopup({ ...popup, open: false })}

        onClose={() => {
          console.log("🔥 POPUP CLOSED");
          console.log("shouldRedirect =", shouldRedirect);

          setPopup((prev) => ({ ...prev, open: false }));

          if (shouldRedirect) {
            console.log("🚀 NAVIGATING TO VIEW PROFILE");
            setShouldRedirect(false);
            navigate("/view-profile");
          }
        }}
      />
    </div>
  );
};

// inline css

const VerifyButton = ({ disabled, onClick }) => (
  <div
    onClick={() => {
      console.log("VERIFY CLICKED | disabled =", disabled);
      if (!disabled && onClick) onClick();
    }}
    style={{
      ...verifyParentStyle,
      opacity: disabled ? 0.5 : 1,
      cursor: disabled ? "not-allowed" : "pointer",
    }}
  >
    <b style={verifyTextStyle}>Verify</b>
  </div>
);

const otpModalOverlay = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: "rgba(0,0,0,0.4)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1030,
};

const otpModalCard = {
  background: "#fff",
  borderRadius: "20px",
  padding: "45px",
  width: "420px",
  boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
  position: "relative",
};

const cardStyle = {
  background: "#fff",
  borderRadius: "20px",
  padding: "32px",
  boxShadow: "0px 10px 30px rgba(0,0,0,0.05)",
};

const titleStyle = {
  textAlign: "center",
  fontSize: "18px",
  fontWeight: 600,
};

const inputStyle = {
  width: "50%",
  padding: "12px 44px 12px 12px",
  borderRadius: "10px",
  border: "1px solid #ddd",
};

const otpBoxStyle = {
  width: "42px",
  height: "48px",
  textAlign: "center",
  fontSize: "18px",
  borderRadius: "8px",
  border: "1px solid #ddd",
};

const verifyBtnStyle = {
  margin: "32px auto 0",

  width: "30%",
  padding: "14px",
  borderRadius: "30px",
  border: "none",
  background: "linear-gradient(90deg, #FF9A4D 0%, #FF5F3D 100%)",
  color: "#fff",
  fontSize: "16px",
  fontWeight: 600,
  cursor: "pointer",
};

const verifyParentStyle = {
  width: "30%",
  height: "45px",
  borderRadius: "100px",
  background:
    "linear-gradient(rgba(255,255,255,0.2), rgba(255,255,255,0.2)), linear-gradient(90deg, rgba(255,119,5,0.88), rgba(230,0,0,0.81))",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginTop: "32px",
  margin: "32px auto 0",
};

const verifyTextStyle = {
  fontSize: "17px",
  color: "#fff",
  fontFamily: "Montserrat",
};

const fieldRowStyle = {
  display: "flex",
  alignItems: "center",
  marginBottom: "24px",
};

const fieldLabelStyle = {
  display: "flex",
  justifyContent: "flex-start",
  width: "40%",
  fontSize: "20px",
  fontWeight: 600,
};

const inputWithIconWrapper = {
  width: "60%",
  position: "relative",
};

const inputWithIconStyle = {
  width: "100%",
  height: "47px",
  borderRadius: "7px",
  border: "0.8px solid rgba(79,79,79,0.12)",
  padding: "0 44px 0 15px",
  fontSize: "15px",
};

const inputIconStyle = {
  position: "absolute",
  right: "12px",
  top: "50%",
  transform: "translateY(-50%)",
  width: "35px",
  height: "22px",
};

const checkboxRowStyle = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
  marginTop: "24px",
};

const dateInputStyle = {
  width: "100%",
  height: "47px",
  borderRadius: "7px",
  border: "0.8px solid rgba(79,79,79,0.12)",
  padding: "0 44px 0 15px",
  fontSize: "15px",
  fontFamily: "Montserrat",
  backgroundColor: "#fff",
  cursor: "pointer",

  // 🔥 remove ugly browser styles
  appearance: "none",
  WebkitAppearance: "none",
  MozAppearance: "none",
};

const calendarIconStyle = {
  position: "absolute",
  right: "14px",
  top: "50%",
  transform: "translateY(-50%)",
  fontSize: "18px",
  pointerEvents: "none",
  opacity: 0.6,
};

dateInputStyle[":hover"] = {
  border: "0.8px solid #FF7A00",
};

dateInputStyle[":focus"] = {
  outline: "none",
  border: "0.8px solid #FF7A00",
  boxShadow: "0 0 0 2px rgba(255,122,0,0.15)",
};

const otpCaretStyle = {
  width: "2px",
  height: "22px",
  background: "#FF7A00",
  animation: "blink 1s step-start infinite",
};

const otpCaretKeyframes = `
@keyframes blink {
  50% { opacity: 0; }
}
`;
